import { AdBlockDetector } from "@Engage.Data/modules/adBlockDetector/AdBlockDetector";
import { eventsService, AppEvents } from "@Engage.Core";
let adBlockPromise = null;
export class AdBlockQualifier {
    constructor() {
        this.key = "AdBlock";
    }
    async process() {
        // Lazy-init: start detection on first process() call (DOM is ready by then)
        // rather than at module load time, avoiding race conditions during SDK init.
        if (!adBlockPromise) {
            adBlockPromise = AdBlockDetector.getInstance()
                .init()
                .then(detected => {
                if (detected) {
                    eventsService.dispatch(AppEvents.AdblockFound, null);
                }
                return detected ? "true" : "false";
            })
                .catch(() => "false");
        }
        return adBlockPromise;
    }
}
